import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
/**
  Componente que representa un botón personalizable.
  Este componente permite configurar el tema, tamaño, texto y estado del botón,
  y emite un evento cuando se hace clic en él.
**/
@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent implements OnInit {
 /**
    Tema del botón (ej. 'primary', 'secondary', etc.).
    @type {string}
    @default 'primary'
  **/
    @Input() theme = 'primary';

    /**
      Ancho del botón en píxeles o porcentaje.
      @type {string}
      @default '92px'
    **/
    @Input() width = '92px';
  
    /**
      Altura del botón en píxeles o porcentaje.
      @type {string}
      @default '56px'
    **/
    @Input() height = '56px';
  
    /**
      Texto que se muestra dentro del botón.
      @type {string}
    **/
    @Input() text = '';
  
    /**
      Indica si el botón está deshabilitado.
      @type {boolean}
      @default false
    **/
    @Input() disabled = false;
  
    /**
      Tamaño de la fuente del texto del botón.
      @type {string}
    **/
    @Input() fontSize = '';
  
    /**
      Grosor de la fuente del texto del botón.
      @type {string}
    **/
    @Input() fontWeight = '';
  
    /**
      Evento que se emite cuando se hace clic en el botón.
      @type {EventEmitter<any>}
    **/
    @Output() amClick: EventEmitter<any>;
  constructor() {
    this.amClick = new EventEmitter<any>();
  }

  ngOnInit(): void {}
  onClick(): void {
    this.amClick.emit();
  }

}
